import SVGIcon from '~/components/ui/Icons/SVGIcon';

type DiscountCardProps = {
  discountPercentage: number;
  title: string;
  description: string;
  extraClasses?: string;
};

const DiscountCard = ({ discountPercentage, title, description, extraClasses }: DiscountCardProps) => {
  return (
    <div
      className={`discount-card d-flex align-items-stretch rounded-3 ${extraClasses}`}
      style={{ boxShadow: '0px 1px 2px 0px #1B10280F, 0px 1px 3px 0px #1B10281A' }}
    >
      <div
        className="bg-accent-500 rounded-start-3"
        style={{ width: 8 }}
      />
      <div className="flex-grow-1 fo-border-sm border-accent-100 rounded-end-3">
        <div className="p-3 d-flex justify-content-between fo-border-bottom-sm border-accent-100">
          <h4 className="text-1 -medium">{title}</h4>
          <SVGIcon
            iconType="discount"
            fill="#6610F2"
          />
        </div>
        <div className="p-3">
          <div className="fo-display-3">-{discountPercentage}%</div>
          <p className="mt-1 text-1">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default DiscountCard;
